import styled from "styled-components";

export const Container = styled.div<{ $overlay?: boolean }>`
  padding-bottom: 5rem;

  ${({ theme }) => theme.mediaQueries.tablet} {
    padding-bottom: 10rem;
  }

  ${({ theme }) => theme.mediaQueries.desktop} {
    padding-top: 2.5rem;
  }
`;
